// extracted by mini-css-extract-plugin
export var tosLink = "_bd-0";